import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const FlexSpaced = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;

	@media ${Breakpoints.mobile} {
		grid-template-columns: 1fr;
		grid-gap: 1rem;
		> div.collapse-container > div.hours {
			display: grid;
			width: 100%;
			align-items: center;
			grid-template-areas:
				'title title title'
				'from to time';
			grid-template-columns: 2fr 0.5fr 2fr;
			grid-template-rows: 1fr 1fr;
			> span.title {
				grid-area: title;
			}
			> div.fromtime {
				grid-area: from;
			}
			> span.to {
				grid-area: to;
			}
			> div.totime {
				grid-area: time;
			}
		}
	}
	> div.hours {
		width: 100%;
		display: grid;
		grid-template-columns: 2fr 2fr 0.3fr 2fr;
		align-items: center;
		grid-gap: 1rem;
		> span {
			justify-self: right;
		}
	}
	> div.day {
		position: relative;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		> div.expandIcon {
			position: absolute;
			right: 0;
		}
	}
`;

export const Flex = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
`;

export const DayName = styled.div`
	min-width: 6.25rem;
`;

export const FullDayWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: start;
	gap: 1rem;
	padding: 2rem 0;
`;

export const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	gap: 1rem;
`;
